import { render, staticRenderFns } from "./SidebarContentContainer.vue?vue&type=template&id=6ca0c238&scoped=true&"
import script from "./SidebarContentContainer.vue?vue&type=script&lang=js&"
export * from "./SidebarContentContainer.vue?vue&type=script&lang=js&"
import style0 from "./SidebarContentContainer.vue?vue&type=style&index=0&id=6ca0c238&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca0c238",
  null
  
)

export default component.exports